import { ObjectTypeId } from '@dmc/ui';
import { TFunction } from 'i18next';

export const TranslationNamespaceBackend = 'backend';

export const hardwareTypeFromDto = (hardwareType: string): string => {
  switch (hardwareType) {
    // FIXME: This case should use a translation.
    case 'IVUPlus':
      return 'IVU+';
    default:
      return hardwareType;
  }
};

export const getObjectType = (t: TFunction, objectType?: number): string => {
  if (typeof objectType === 'number' && typeof ObjectTypeId[objectType] !== 'undefined') {
    const memberKey = ObjectTypeId[objectType]; // E.g. 'Dozer'
    return t(`Enum.ObjType.${memberKey}`, { ns: TranslationNamespaceBackend });
  } else {
    return t('Unknown');
  }
};

export const getObjectName = (t: TFunction, name?: string | null, isDotNetix?: boolean): string => {
  return isDotNetix === true ? t('ObjectDetection') : name != null ? name : '-';
};
